import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { memo } from "react";
import { ColorsProvider } from "../providers/ColorsProvider";
import { SlotsProvider } from "../providers/SlotsProvider";
import { useDefaultProps } from "../providers/utils/defaultProps";
import { mergeSx } from "../system";
import { Box } from "./Box";
import { Typography } from "./Typography";
export const badgeDotClasses = {
    root: "MinervaBadgeDot-root",
};
export const badgeDotSlots = {
    root: Box,
    label: Typography,
};
export const BadgeDot = memo((props) => {
    const { color = "surface", colorSet, invertColors, slots, slotProps, children, className, } = useDefaultProps({ component: "BadgeDot", props });
    return (_jsx(ColorsProvider, { color: color, colorSet: colorSet, invertColors: invertColors, children: (colorStyles) => (_jsx(SlotsProvider, { baseSlots: badgeDotSlots, slots: slots, children: ({ label: Label, root: Root }) => {
                return (_jsx(Root, { ...slotProps?.root, className: clsx([badgeDotClasses.root, className]), sx: mergeSx({
                        ...colorStyles,
                        borderRadius: (theme) => theme.radius.full,
                        minHeight: 2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        paddingX: children !== undefined ? 1 : 0,
                        paddingY: children !== undefined ? 0.25 : 0,
                        minWidth: children !== undefined ? 4.25 : 2,
                    }, { ...slotProps?.root?.sx }), children: typeof children === "string" || typeof children === "number" ? (_jsx(Label, { variant: "body4", ...slotProps?.label, children: children })) : (children) }));
            } })) }));
});
//# sourceMappingURL=BadgeDot.js.map